var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',[_c('GlobalDetailHeader',{attrs:{"title":"详情"}}),_c('DetailContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }